import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgBookmark = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M20 21a1 1 0 0 1-1.496.868L12 18.151l-6.504 3.717A1 1 0 0 1 4 21V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgBookmark)
export default ForwardRef
